module.exports = __webpack_public_path__ + "static/media/defense.d9e2cde3.jpg";